/** Espíritu musical (personaje del menú de configuración). */
export const CLING_SPIRIT_IMG = '/junior-assets/images/espiritumusical.png';

export type ClingSpiritSize = 'sm' | 'md' | 'lg' | 'xl';

export const CLING_SPIRIT_SIZES: Record<ClingSpiritSize, number> = {
  sm: 44,
  md: 72,
  lg: 96,
  xl: 128,
};
